export const FEATURE_FLAG_OFFER_DRAFTS = 'offer-drafts';
export const FEATURE_FLAG_AVAILABILITY_CALENDAR = 'availability-calendar';
export const FEATURE_FLAG_MAP_COORDINATE_SEARCH = 'map-coordinate-search';
export const FEATURE_FLAG_MAP_TEXT_SEARCH = 'map-text-search';
export const FEATURE_FLAG_PUBLIC_OFFER_LINKS = 'public-offer-links';
